import React from 'react'


export default props => (
    <svg viewBox="0 0 100 100" { ...props }>
        <path d="M59.667975 65.87145h-29.25v-8.325c0-8.07705 6.54795-14.625 14.625-14.625s14.625 6.54795 14.625 14.625v8.325zM45 22.636125c4.34925 0 7.875 3.52575 7.875 7.875s-3.52575 7.875-7.875 7.875-7.875-3.52575-7.875-7.875 3.52575-7.875 7.875-7.875zM45 0C20.147175 0 0 20.147175 0 45s20.147175 45 45 45 45-20.147175 45-45S69.852825 0 45 0z" />
    </svg>
)